import React from 'react';
import classNames from 'classnames'
import { FormattedMessage, FormattedTime } from 'react-intl';
import { FanFeedGallery } from './FanFeedGallery'
import styles from './FanFeedPostList.scss'

import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TableHeader,
  TableHeaderColumn
} from 'material-ui/Table';

import List from '../../List/List';

import LoadMore from '../../LoadMore';
import { FormattedDate } from 'react-intl';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';
import LoadingSpinner from '../../LoadingSpinner';

import NameFormatter from '../../NameFormatter';



class FanFeedPostList extends List {
  static contextTypes = {
    muiTheme: React.PropTypes.object
  };
  state = {
    selected: undefined,
    sortBy: undefined,
    show_all: undefined
  }
  constructor() {
    super();
    this.confirmRemoveMessage = (
      <FormattedMessage
        id="fanBoxMessage.remove"
        defaultMessage="Are you sure you want to delete post?"
      />
    );
  }
  componentWillReceiveProps({ routeParams }){
    const { id } = routeParams
    this.setState({ selectedId: id })
    // console.log(newProps)
  }
  async onAcceptItem(id){
    await this.props.items[id].accept()
  }
  async onDeclineItem(id, message){
    await this.props.items[id].reject(message)
  }
  async onDeleteItem(id){
    this.props.delete(this.props.items[id])
  }
  onSelectItem(id){
    let { edit } = this.props
    edit(id)
    // this.setState({ selected: id })
  }
  sortBy(sortBy){
    sortBy = this.state.sortBy === sortBy ? undefined : sortBy
    this.setState({ sortBy  })
  }
  filterBy(){
    this.setState({ show_all: !this.state.show_all  })
  }
  render() {

    let { list, items, hasMore, loading } = this.props;
    let { selectedId, sortBy } = this.state;
    let records = list.map(id => items[id]);

    let { palette: { labelColor } } = this.context.muiTheme;
    let tableHeaderStyle = { color: labelColor, boxSizing: 'border-box' };
    const clickableHeaderStyle = { cursor: 'pointer', paddingLeft: 8, paddingRight: 8, border: '1px dashed transparent' };
    let fixedColumnHeaderStyle = { ...tableHeaderStyle, width: 140 };
    let idHeaderColumnStyle = { ...tableHeaderStyle, maxWidth: 370 };
    let { tableHeaderColumn } = this.context.muiTheme;

    let sortedRecords = sortBy ? records.sort((a, b) => sortBy === 'likes_count'
        ? (b[sortBy] - a[sortBy])
        : (b[sortBy] === 'in_review' ? 2 : b[sortBy] === 'accepted' ? 1 : 0) - (a[sortBy] === 'in_review' ? 2 : a[sortBy] === 'accepted' ? 1 : 0))
      : records
      
    sortedRecords = this.state.show_all ? sortedRecords : sortedRecords.filter(record => record.status === 'in_review')
    const selected = records.find(item => item.id === selectedId)
    const { createdBy = {} } = selected || {}
    const selectedAuthor = selected ? `${createdBy.first_name} ${createdBy.last_name}` : undefined
    const authorRecords = selected ? records.filter(item => `${item.createdBy.first_name} ${item.createdBy.last_name}` === selectedAuthor) : []

    return (
      <div style={ selectedId ? {
          overflow: 'hidden',
          maxHeight: 'calc(100vh - 50px)'
        } : {} }>
        {selected ? <FanFeedGallery
          key={selectedId}
          onDeclineItem={(id, message) => this.onDeclineItem(id, message)}
          onAcceptItem={(id) => this.onAcceptItem(id)}
          onSelectItem={(id) => this.onSelectItem(id)}
          onDeleteItem={(id) => this.onDeleteItem(id)}
          selected={selectedId}
          records={sortedRecords}
          authorRecords={ authorRecords }
          onClose={ () => this.onSelectItem() }
        /> : null }
        <LoggedAppBar title="FanFeed Posts" isStatic />
        <LoadingSpinner show={loading}>
          <LoadMore active={hasMore} loadMore={() => this.loadMore()}>
            <Table selectable={false}>
              <TableHeader
                adjustForCheckbox={false}
                displaySelectAll={false}
                enableSelectAll={false}
                style={{
                  backgroundColor: tableHeaderColumn.bgColor
                }}
              >
                <TableRow>
                  <TableHeaderColumn style={idHeaderColumnStyle}>
                    <span>Author</span>
                  </TableHeaderColumn>
                  <TableHeaderColumn style={tableHeaderStyle}>
                    <span style={{ ...clickableHeaderStyle,
                      [sortBy === 'likes_count' ? 'border' : 'borderBottom']: '1px dashed #fff'
                    }} onClick={() => this.sortBy('likes_count')}>Likes</span>
                  </TableHeaderColumn>
                  <TableHeaderColumn style={fixedColumnHeaderStyle}>
                    <span style={{ ...clickableHeaderStyle,
                      [sortBy === 'status' ? 'border' : 'borderBottom']: '1px dashed #fff'
                    }} onClick={() => this.sortBy('status')}>Status</span>
                  </TableHeaderColumn>
                  <TableHeaderColumn style={fixedColumnHeaderStyle}>
                    <span onClick={() => this.sortBy('createDate')}>Creation date</span>
                  </TableHeaderColumn>
                  <TableHeaderColumn style={fixedColumnHeaderStyle} >
                    <span onClick={() => this.filterBy('status')}>Show all <input type='checkbox' checked={this.state.show_all} /></span>
                  </TableHeaderColumn>
                </TableRow>
              </TableHeader>

              <TableBody displayRowCheckbox={false}>
                {sortedRecords.length > 0 ? (
                  <TableRow>
                    <TableRowColumn columnNumber={5}>
                      <div className={ styles.FanFeedPostList }>
                  {  sortedRecords.map(
                    ({
                      id,
                      image,
                      likes_count,
                      tags,
                      createDate,
                      createdBy,
                      video_url,
                      status
                    }) => (
                      <div key={id} className={classNames(styles[status])}>
                        <img src={image._medium} />
                        <div>
                          <div className={ styles.info }>
                            <span>{ likes_count }</span>
                            <span>{ tags.map(tag => `#${tag}`).join(', ') }</span>
                            <span>
                              <FormattedDate value={createDate} />
                              <br />
                              <FormattedTime value={createDate} />
                            </span>
                            <NameFormatter user={createdBy}></NameFormatter>
                          </div>
                          <button onClick={ () => this.onSelectItem(id) } className={ styles.play }>{ video_url ? '▶' : '' }</button>
                        </div>
                      </div>
                    ))}
                    </div>
                    </TableRowColumn>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableRowColumn columnNumber={4}>Empty list</TableRowColumn>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </LoadMore>
        </LoadingSpinner>
      </div>
    );
  }
}

export default FanFeedPostList



// WEBPACK FOOTER //
// ./src/components/FanFeed/FanFeedPostList/FanFeedPostList.jsx